import * as React from 'react';
import { cn } from '../../utils';

const colorMap = {
  pink: 'var(--riso-pink)',
  teal: 'var(--riso-teal)',
  amber: 'var(--riso-amber)',
  blue: 'var(--riso-blue)',
  cream: 'hsl(var(--background))',
} as const;

interface DecorativeBlobProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  color?: keyof typeof colorMap;
}

const DecorativeBlob = React.forwardRef<HTMLDivElement, DecorativeBlobProps>(
  ({ size = 200, color = 'pink', className, style, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn('pointer-events-none', className)}
      style={{
        width: size,
        height: size,
        backgroundColor: colorMap[color],
        borderRadius: '50%',
        ...style,
      }}
      {...props}
    />
  ),
);
DecorativeBlob.displayName = 'DecorativeBlob';

export { DecorativeBlob };
